import { Injectable, Injector } from '@angular/core';
import localeFrCa from '@angular/common/locales/fr-CA';
import localeRO from '@angular/common/locales/ro';
import englishCanada from '@angular/common/locales/en-CA';
import russian from '@angular/common/locales/ru';
import portuguese from '@angular/common/locales/pt-PT';
// double check if this is correct
import portuguesebrazil from '@angular/common/locales/pt';
import spanish from '@angular/common/locales/es';
import spanishMexico from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';
import { Platform } from '@ionic/angular';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';

// register all the required ones
registerLocaleData(localeFrCa);
registerLocaleData(localeRO);
registerLocaleData(englishCanada);
registerLocaleData(russian);
registerLocaleData(portuguese);
registerLocaleData(spanish);
registerLocaleData(portuguesebrazil);
registerLocaleData(spanishMexico);

@Injectable({
	providedIn: 'root'
})
export class LocaleService {
	private locale: string;

	public constructor(
		private platform: Platform,
		private injector: Injector
	) {}

	public getLocaleName(): string {
		if (!this.locale) {
			throw new Error('Plese initialize locale before calling this method');
		}
		return this.locale;
	}

	public async initLocaleName(): Promise<string> {
		if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
			if (navigator.languages !== undefined) {
				this.locale = navigator.languages[0];
			} else {
				this.locale = navigator.language;
			}
			return this.locale;
		}

		const globalization = this.injector.get(Globalization);
		this.locale = (await globalization.getPreferredLanguage()).value;

		return this.locale;
	}
}
